import { Card, Col, Drawer, Radio, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import CardiopulmonaryForm from "./Forms/CardiopulmonaryForm/CardiopulmonaryForm";
import NeuroForm from "./Forms/NeuroForm/NeuroForm";
import OrthoForm from "./Forms/Orthoform/OrthoForm";
import "./OPForms.css";
import SportsForm from "./Forms/SportsForm/SportsForm";
import { getCookie } from "../../../helpers/localStorage";
import { Role } from "../../../constants/defaultKeys";
import { formatPatientAge } from "../../../helpers/formatAge";
import { UiButton, UiTag } from "../../ui";

const emrOptions = [
  { label: "Cardiopulmonary EMR", value: "cardiopulmonary_emr" },
  { label: "Neuro EMR", value: "neuro_emr" },
  { label: "Ortho EMR", value: "ortho_emr" },
  { label: "Sports EMR", value: "sports_emr" },
  // { label: "Other EMR", value: "other_emr" },
];

const PhysioOP = ({ patientData, admission, refreshOp }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const admissionId = searchParams?.get("aid");
  const status = searchParams?.get("service");
  const type = searchParams?.get("type");
  const navigate = useNavigate();
  const [open, setOpen] = useState(status);
  const [radioValue, setRadioValue] = useState("cardiopulmonary_emr");

  const handleNext = () => {
    searchParams.set("type", radioValue);
    searchParams.set("start", "1");
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  const handlePrev = () => {
    searchParams.delete("type");
    searchParams.set("service", "ia");
    searchParams.delete("start");
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
    refreshOp?.();
  };

  const handleClose = () => {
    searchParams?.delete("type");
    searchParams?.delete("start");
    searchParams?.set("service", "ia");
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
    refreshOp();
  };

  useEffect(() => setOpen(status), [status]);

  const renderComponent = () => {
    switch (type) {
      case "cardiopulmonary_emr":
        return (
          <CardiopulmonaryForm
            admissionId={admissionId}
            handleClose={handleClose}
            patientData={patientData}
          />
        );
      case "neuro_emr":
        return (
          <NeuroForm
            admissionId={admissionId}
            handleClose={handleClose}
            patientData={patientData}
          />
        );
      case "ortho_emr":
        return (
          <OrthoForm
            admissionId={admissionId}
            handleClose={handleClose}
            patientData={patientData}
          />
        );
      case "sports_emr":
        return (
          <SportsForm
            admissionId={admissionId}
            handleClose={handleClose}
            patientData={patientData}
          />
        );
      case "other_emr":
        return (
          <OrthoForm
            admissionId={admissionId}
            handleClose={handleClose}
            other={true}
          />
        );
    }
  };

  const getLabel = () => {
    const typeMapping = {
      cardiopulmonary_emr: "Cardiopulmonary EMR",
      neuro_emr: "Neuro EMR",
      ortho_emr: "Ortho EMR",
      sports_emr: "Sports EMR",
      other_emr: "Other EMR",
    };

    return typeMapping[type] || "";
  };

  return (
    <>
      {type ? (
        <>
          <Drawer
            open={open}
            onClose={handleClose}
            width={"100%"}
            title={
              <Row gutter={[8, 8]}>
                <Col span={10}>
                  <Space>
                    <LeftOutlined
                      onClick={handlePrev}
                      className="physio-op-back-icon"
                    />
                    <Typography className="physio-op-patient-name">
                      {`${patientData?.first_name || " "} ${
                        patientData?.last_name || " "
                      }`}
                    </Typography>
                  </Space>
                  <br />
                  <Space style={{ marginLeft: "48px" }}>
                    <UiTag size="sm">
                      {formatPatientAge(patientData?.age, patientData?.gender)}
                    </UiTag>
                    <UiTag size="sm">OP ID: {admission?.op_id}</UiTag>
                  </Space>
                </Col>
                <Col span={14}>
                  <Typography className="physio-op-drawer-label">
                    {getLabel()}
                  </Typography>
                </Col>
              </Row>
            }
            closeIcon={false}
          >
            {renderComponent()}
          </Drawer>
        </>
      ) : (
        <Card
          title={
            <Typography className="physio-op-card-title">
              Choose Type of EMR
            </Typography>
          }
          // headStyle={{border:"none"}}
          style={{ width: "100%" }}
        >
          <Row gutter={[8, 8]}>
            <Col span={24}>
              {
                <Radio.Group
                  value={radioValue}
                  onChange={(e) => setRadioValue(e?.target?.value)}
                >
                  {emrOptions?.map((option) => (
                    <>
                      <Radio
                        className="physio-op-radio-option"
                        value={option?.value}
                      >
                        {option.label}
                      </Radio>
                      <br />
                    </>
                  ))}
                </Radio.Group>
              }
            </Col>
            <Col span={24} className="flex-end">
              <UiButton
                variant="primary"
                size="md"
                className="physio-op-next-btn"
                onClick={handleNext}
              >
                Next
              </UiButton>
            </Col>
          </Row>
        </Card>
      )}
      {/* <div className="footer">
        <Button 
      </div> */}
    </>
  );
};

export default PhysioOP;
